import {makeQRCode} from '@solid-integrations/qrcode-generator'
import {useI18n} from '../../i18n'
import {useIcon} from '../icon/useIcon'
import './forgotPassword.css'
import { useConfig } from '../config/useConfig'
import { useSelector } from '../../store'
import { SolidQR } from "solid-qr"
import {FocusGroupProvider, FocusableProvider} from '../focus/index'
import { createEffect, onMount, onCleanup } from 'solid-js'
import { isPlatform } from '../../utils'
import { useSpatialNavigation } from '../../spatialNavigation'
import { isBackKey } from '../../utils'

interface ForgotPasswordProps {
    onLoginTVForgetClose: () => void;
}

const ForgotPassword = (props:ForgotPasswordProps) => {
    const icons = useIcon()
    const {getI18n} = useI18n()
    const {getConfig} = useConfig()
    const {setFocus} = useSpatialNavigation()

    const locale = useSelector((state: any) => state?.language?.locale)

    onMount(() => {
        !isPlatform('laptop') && setFocus('loginformforgotclosebutton')
        window.addEventListener('keydown', backKeyHandler)
    })

    const handleForgetPasswordClose = () => {
        // Perform login (Here you might make an API call to validate credentials)
        props?.onLoginTVForgetClose && props?.onLoginTVForgetClose()
    }

    const backKeyHandler = (event:any)=>{
        if(isBackKey(event)){
            props?.onLoginTVForgetClose && props?.onLoginTVForgetClose()
        }
    }

    onCleanup(()=>{
        window.removeEventListener('keydown', backKeyHandler);
    })

    return (
        <FocusGroupProvider id={`logintvForgotPasswordform-screen`} focusKey={`logintvforgotpasswordform-screen`} onFocus={() => {}}>
        <div
            class="forgot-password-appContainer"
            style={{
                display: 'flex',
                'justify-content': 'center',
                'align-items': 'center',
                height: '100vh',
                'background-image': `url(${icons.get('LoginBackdrop')})`,
                'background-size': 'cover',
                direction: `${getConfig().rtlLanguages.includes(locale()) ? 'rtl' : 'ltr'}`
            }}
        >
            <div class="forgotPasswordContainer">
                <div class="client_logo_loading_logout_screen"></div>

                <div class='qr-code-forgot-password'>
                    <SolidQR text={getConfig()?.forgotPasswordQr} options={{
                    width: 500, 
                    }}/>
                </div>
                <div class='forgotpassword-desc'>
                {getI18n()?.formatMessage({ id: 'FORGOT_SCAN_QR_CODE' })} {getConfig()?.forgotPasswordQr}
                </div>
                <FocusableProvider
                    id={'loginformforgotclosebutton'}
                    focusKey={`loginformforgotclosebutton`}
                    onEnterPress={() => handleForgetPasswordClose()}
                    onFocus={() => {
                        
                    }}
                >
                    {(focused: any) => (
                        <button
                            id="loginforgotclosebutton"
                            class={`login-content-button-forgot-close-tv ${focused?.() ? 'login-content-button-tv-forgot-close-focus' : ''}`}
                            tabIndex={focused?.() ? 0 : -1}
                            type="submit"
                            onClick={()=>{
                                handleForgetPasswordClose()
                                }
                            }
                        >
                            {getI18n()?.formatMessage({id: 'CLOSE'})}
                        </button>
                    )}
                </FocusableProvider>
            </div>
        </div>
        </FocusGroupProvider>
    )
}

export default ForgotPassword
